export const INSTALL_SKILLS_YIELD_EVERY = 16;
